import React, {useCallback, useEffect} from "react";
import {useOutletContext, useParams} from "react-router-dom";
import {
    PublicTransitLayerEntityName,
    PublicTransitRouteEntity,
    PublicTransitScheduleElementEntity
} from "../../../../api/entities/replancity_PublicTransitLine";
import EntityEditor from "../../../../components/Entities/EntityEditor";
import {removeEntity} from "../../../../redux/entity/entity-reducer";
import {useDispatch} from "react-redux";
import {TransitRouteContext} from "../../types";
import {useToastContext} from "../../../../context/toastContext";
import {useTranslation} from "react-i18next";
import EntityManagerCleaner from "../../../../components/Entities/EntityManagerCleaner";


const DepartureEdit = () => {
    const entityName = PublicTransitLayerEntityName.DEPARTURE;
    const {departureId} = useParams<any>();
    const {scheduleId} = useOutletContext<TransitRouteContext>();
    const dispatch = useDispatch();
    const {addToast} = useToastContext();
    const {t} = useTranslation();

    useEffect(() => {
        return () => {
            dispatch(removeEntity(entityName));
        }
    }, [])

    //TODO update routes, because "departures/new" is a single step and '../' not navigates to "departures" as expected
    const onSaveFn = useCallback((entity: PublicTransitRouteEntity) => {
        if (!departureId) {
            return `../${entity.id}/edit`;
        }
    }, [departureId]);

    const onDeleteFn = useCallback(() => {
        addToast(t("transit-lines.last-departure-deletion"), "warning");
        return '../../';
    }, []);

    const saveArgsFn = useCallback((entity: PublicTransitScheduleElementEntity) => ({
        publicTransitSchedule: {id: scheduleId}
    }), [scheduleId]);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor<PublicTransitScheduleElementEntity>
                entityId={departureId!}
                entityName={entityName}
                layerId={''} // make optional?
                saveFnArgs={saveArgsFn}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!departureId}
            />
        </EntityManagerCleaner>
    )
}

export default DepartureEdit;